import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { BrandsService } from 'src/app/core/services/brands.service';
import { vendorService } from 'src/app/core/services/vendor.service';
import { brand, brandList } from 'src/app/models/brand';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { ToasterService } from 'src/app/core/services/toastr.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'megastore-admin-assign-brand',
  templateUrl: './assign-brand.component.html',
  styleUrls: ['./assign-brand.component.scss']
})
export class AssignBrandComponent implements OnInit, OnDestroy {
  brands: brand[] = [];
  selectedBrands: string[] = [];
  private destroy$ = new Subject<void>();
  isLoadingBrands: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { vendorId: string; assignedBrands?: string[] },
    private dialogRef: MatDialogRef<AssignBrandComponent>,
    private brandsService: BrandsService,
    private vendorService: vendorService,
    private spinnerService: SpinnerService,
    private toasterService: ToasterService,
    private translateService: TranslateService
  ) {
    if (data.assignedBrands) {
      this.selectedBrands = [...data.assignedBrands.map((brand: any) => brand.brandId._id)];
      console.log("selectedBrands", this.selectedBrands);
      console.log("assignedBrands", data.assignedBrands);
    }
  }

  ngOnInit(): void {
    this.loadBrands();
  }

  loadBrands(): void {
    this.isLoadingBrands = true;
    this.spinnerService.addToLoader('loadBrands');
    this.brandsService
      .getAllBrandList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.isLoadingBrands = false;
          this.spinnerService.removeFromLoader('loadBrands');
          this.brands = res || [];
        },
        error: () => {
          this.isLoadingBrands = false;
          this.spinnerService.removeFromLoader('loadBrands');
        }
      });
  }

  onBrandSelectionChange(selectedBrandIds: string[]): void {
    this.selectedBrands = selectedBrandIds;
    console.log("selectedBrands", this.selectedBrands);
  }

  save(): void {
    this.spinnerService.addToLoader('assignBrands');
    const payload: any = {
      brandIds: this.selectedBrands,
      vendorId: this.data.vendorId
    };
    console.log(payload);
    this.vendorService
      .assignBrand(payload,)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.spinnerService.removeFromLoader('assignBrands');
          this.toasterService.successToastr(
            this.translateService.instant('BrandsAssignedSuccessfully')
          );
          this.dialogRef.close(this.selectedBrands);
        },
        error: () => {
          this.spinnerService.removeFromLoader('assignBrands');
        }
      });
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

